export class ProspectConfirm {
    constructor (
        public FirstName: string = null,
        public MiddleName: string = null,
        public LastName: string = null,
        public Address: string = null,
        public City: string = null,
        public State: string = null,
        public Zip: string = null,
        public LicenseNumber: string = null,
        public LicenseExpiration: string = null,
        public DateOfBirth: string = null,
        public LicensePictureSource: string = null,
        public HomePhone: string = null,
        public CellPhone: string = null,
    ) { }
}
